import { EditorialLink } from 'models/EditorialLink';
import { IconArrow } from 'components/Shared/Icon';
import { rm, NO_ELEMENT, hasElements } from 'utils';
import { Section } from 'components/Section';
import Image from 'components/Shared/Image';
import { NotifyLink } from 'components/Shared/NotifyLink';
import styles from './editorials.scss';
import ResponsiveImage from 'components/Shared/Image/ResponsiveImage';
import { SrcSet } from 'components/Shared/Image/SrcSet';
import { EditorialsBlock } from 'models/EditorialsBlock';
import { ThemeMeta } from 'models/SectionBlock';
import { EditorialsMenu } from './editorialsMenu';
import { EditorialTitle } from './editorialTitle';
import { Masonry } from './masonry';
import { EditorialHeader } from './themes/BGH/editorialHeader';

const DEFAULT_WIDTH = 284;
const DEFAULT_HEIGHT = 194;
const MEDIUM_WIDTH = 391;
const MEDIUM_HEIGHT = 267;
const LARGE_WIDTH = 610;
const LARGE_HEIGHT = 417;

const sizes: { [key: string]: SrcSet } = {
  default: {
    viewWidth: DEFAULT_WIDTH,
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT
  },
  medium: {
    viewWidth: MEDIUM_WIDTH,
    width: MEDIUM_WIDTH,
    height: MEDIUM_HEIGHT
  },
  large: {
    viewWidth: LARGE_WIDTH,
    width: LARGE_WIDTH,
    height: LARGE_HEIGHT
  }
};

const responsive: ResponsiveImage = {
  srcSet: Object.values(sizes),
  sizes: `(max-width: 420px) ${sizes.medium.width}px,
  (max-width: 639px) ${sizes.large.width}px,
  (max-width: 1499px) ${sizes.medium.width}px,
  ${sizes.default.width}px`
};

const THEME: ThemeMeta = {
  surface: '#F2F2F2'
};

interface EditorialProps extends EditorialLink {
  showIntroduction?: boolean;
}

export const Editorial = ({
  url,
  ticket,
  image,
  title,
  introduction,
  showIntroduction = true
}: EditorialProps) => {
  return (
    <div className={styles.article}>
      <NotifyLink url={url} ticket={ticket}>
        <div className={styles.innerWrapper}>
          <Image
            responsive={responsive}
            paddingBottom
            className={styles.image}
            {...image}
            height={sizes.default.height}
            width={sizes.default.width}
          />
          <div className={styles.articleInfo}>
            <h4>{title}</h4>
            {showIntroduction && <p>{introduction}</p>}
            <div className={styles.linkWrapper}>
              <span>{rm('reportage_read_reportage_link_text')}</span>
              <IconArrow size="tiny" />
            </div>
          </div>
        </div>
      </NotifyLink>
    </div>
  );
};

interface MergedProps extends EditorialsBlock {
  sectionClassName?: string;
  children: React.ReactNode;
  title?: string;
}

export const EditorialsSection = ({ editorials, sectionClassName, children }: MergedProps) => {
  return hasElements(editorials) ? (
    <Section theme={THEME} contentClassName={styles.base} className={sectionClassName}>
      <EditorialHeader />
      <EditorialTitle />
      <EditorialsMenu />
      <Masonry>
        {editorials.map(editorial => (
          <Editorial key={editorial.url} {...editorial} />
        ))}
      </Masonry>
      <div className={styles.buttonWrapper}>{children}</div>
    </Section>
  ) : (
    NO_ELEMENT
  );
};
